import type { CheckInPermissions } from "../../api/dto/ProjectCheckIn";
import type { QuestionSetType } from "../../api/dto/QuestionSet";

export const checkInPermissionOptions: [
  keyof Omit<CheckInPermissions, "accessibleQuestionSetTypes">,
  string,
][] = [
  ["canExecuteAssessments", "Assessments uitvoeren"],
  ["canExportAssessments", "Assessments exporteren"],
  ["canAccessAllAssessments", "Alle assessments inzien"],
  ["canAccessAssessmentHistory", "Assessmentgeschiedenis inzien"],
  ["canManageProjects", "Project beheren"],
  ["canManageAssessments", "Assessments beheren"],
  ["canManageAssessmentsDestructive", "Assessments verwijderen"],
];

export const checkInQuestionSetOptions: [QuestionSetType, string][] = [
  ["Fct", "Flange competentie test"],
  ["Rct", "Rigger competentie test"],
  ["Fir", "Field inspection report"],
  ["Lir", "Lifting inspection report"],
];
